// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-chrono-cam {
  position: absolute;
  z-index: 4;
  left: 10px;
  right: 10px;
  bottom: 12px;
  margin: 0;
  padding: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 42%;
  overflow: auto;
  border-radius: 12px;
  background: rgba(8, 15, 28, 0.72);
  color: #f8fafc;
  pointer-events: none;
}

.lt-chrono-cam--live {
  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.45);
}

.lt-chrono-cam__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  padding: 4px 6px;
  border-radius: 8px;
}

.lt-chrono-cam__row--running {
  background: rgba(8, 119, 188, 0.35);
}

.lt-chrono-cam__row--rec {
  background: rgba(220, 38, 38, 0.42);
  box-shadow: inset 0 0 0 1px rgba(252, 165, 165, 0.55);
}

.lt-chrono-cam__row--mine {
  outline: 1px solid rgba(253, 224, 71, 0.55);
}

.lt-chrono-cam__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.lt-chrono-cam__rec {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px 1px 4px;
  border-radius: 999px;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #fff;
  background: #dc2626;
  animation: lt-chrono-cam-rec-pulse 1.2s ease-in-out infinite;
}

.lt-chrono-cam__rec::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
}

.lt-chrono-cam__clock {
  font-variant-numeric: tabular-nums;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.lt-chrono-cam__idle {
  opacity: 0.45;
  font-size: 13px;
}

@keyframes lt-chrono-cam-rec-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lt-chrono-cam__rec {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/OffTableChronoCameraHud.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".lt-chrono-cam {\n  position: absolute;\n  z-index: 4;\n  left: 10px;\n  right: 10px;\n  bottom: 12px;\n  margin: 0;\n  padding: 8px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 42%;\n  overflow: auto;\n  border-radius: 12px;\n  background: rgba(8, 15, 28, 0.72);\n  color: #f8fafc;\n  pointer-events: none;\n}\n\n.lt-chrono-cam--live {\n  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.45);\n}\n\n.lt-chrono-cam__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-width: 0;\n  padding: 4px 6px;\n  border-radius: 8px;\n}\n\n.lt-chrono-cam__row--running {\n  background: rgba(8, 119, 188, 0.35);\n}\n\n.lt-chrono-cam__row--rec {\n  background: rgba(220, 38, 38, 0.42);\n  box-shadow: inset 0 0 0 1px rgba(252, 165, 165, 0.55);\n}\n\n.lt-chrono-cam__row--mine {\n  outline: 1px solid rgba(253, 224, 71, 0.55);\n}\n\n.lt-chrono-cam__name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lt-chrono-cam__rec {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 1px 6px 1px 4px;\n  border-radius: 999px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  color: #fff;\n  background: #dc2626;\n  animation: lt-chrono-cam-rec-pulse 1.2s ease-in-out infinite;\n}\n\n.lt-chrono-cam__rec::before {\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.lt-chrono-cam__clock {\n  font-variant-numeric: tabular-nums;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.lt-chrono-cam__idle {\n  opacity: 0.45;\n  font-size: 13px;\n}\n\n@keyframes lt-chrono-cam-rec-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-chrono-cam__rec {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
